// SPDX-License-Identifier: AGPL-3.0-or-later

// The API's epoch clock as seen here, for the shared room TV position: a micup.watch value carries the time the API
// wrote it, and one that changes while I watch arrives a network delay later, so written - received is this
// device's offset less that delay. The largest of the last few is the closest; until one arrives, the local clock.
const SAMPLES = 8;
const offsets: Array<number> = [];

export function sampleServerTime(writtenAtMs: number, receivedAtMs: number = Date.now()): void {
	offsets.push(writtenAtMs - receivedAtMs);
	if (offsets.length > SAMPLES) offsets.shift();
}

export function serverNow(): number {
	return Date.now() + (offsets.length > 0 ? Math.max(...offsets) : 0);
}

export function resetServerClock(): void {
	offsets.length = 0;
}
